import {React} from "react"
import Logo from "../img/Logo.png";

export default function Footer(){
    return(
        <footer className="bg-second-color cursor-pointer">
            <div className="mx-auto max-w-screen-xl px-6 pb-6 pt-16 lg:px-8 lg:pt-24">
                <div className="grid lg:space-x-12 grid-cols-1 gap-12 lg:grid-cols-3">
                    <div className="grid justify-items-center">
                        <div>
                            <div className=" flex items-center flex-col">
                                <img alt ="#" className=" w-28  md:hidden flex" src={Logo} />
                            </div>
                            <img alt ="#" className="md:w-28 hidden md:flex" src={Logo} />
                        </div> 
                        <p className="mt-6 lg:flex hidden tracking-wide leading-relaxed text-white">
                            At CreAsian, we bring the vibrant flavors of Vietnam to Brentwood, California. 
                            Our menu features authentic dishes like Traditional Beef Noodle Soup (Phở), 
                            flavorful Stir-Fried meals, and refreshing Mango Shrimp Salad. Every dish is made with
                            fresh, high-quality ingredients.   
                        </p>
                
                        <ul className="mt-8 flex justify-center gap-6 md:gap-8">
                            <li className="">
                                <a href="https://www.yelp.com/biz/cre-asian-flavors-of-vietnam-brentwood" target="_blank" className="text-teal-700 transition hover:text-teal-700/75">
                                    <img src="https://img.icons8.com/fluent/30/000000/yelp.png"/>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/creasian.lonetree?utm_source=qr" target="_blank" className="text-teal-700 transition hover:text-teal-700/75">
                                    <img src="https://img.icons8.com/fluent/30/000000/instagram-new.png"/>
                                </a>
                            </li>
                            <li>
                                <a href="https://maps.app.goo.gl/NRvhLSGgFTFyAkk89" target="_blank" className="text-teal-700 transition hover:text-teal-700/75">
                                    <img src="https://img.icons8.com/fluency/30/google-logo.png"/>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="grid lg:col-span-2 lg:grid-cols-2 gap-4 justify-items-center">
                        <div className="text-center sm:text-left">
                            <p className="text-lg font-medium text-main-color">Business Hours</p>
                            <ul className="mt-8 space-y-4 text-sm">
                                <li>
                                    <a className=" transition text-white t-underline t-underline-black border-b-yellow-500">
                                        Mon: 8:00 am - 10:00 pm
                                    </a>
                                </li>
                                <li>
                                    <a className=" transition text-white t-underline t-underline-black border-b-yellow-500">
                                        Tues: 8:00 am - 10:00 pm
                                    </a>
                                </li>
                                <li>
                                    <a className=" transition text-white t-underline t-underline-black border-b-yellow-500">
                                        Wed: 8:00 am - 10:00 pm
                                    </a>
                                </li>
                                <li>
                                    <a className=" transition text-white t-underline t-underline-black border-b-yellow-500">
                                        Thu: 8:00 am - 11:00 pm
                                    </a>
                                </li>
                                <li>
                                    <a className=" transition text-white t-underline t-underline-black border-b-yellow-500">
                                        Fri: 8:00 am - 11:00 pm
                                    </a>
                                </li>
                                <li>
                                    <a className=" transition text-white t-underline t-underline-black border-b-yellow-500">
                                        Sat: 8:00 am - 11:00 pm
                                    </a>
                                </li>
                                <li>
                                    <a className=" transition text-white t-underline t-underline-black border-b-yellow-500">
                                        Sun: 8:00 am - 11:00 pm
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="text-center sm:text-left">
                            <p className="text-lg font-medium text-main-color">Contact Us</p>
                            <ul className="mt-8 space-y-5 text-sm">
                                
                                <li>
                                    <a className="flex items-center justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end" href="tel:9255168880">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-5 w-5 shrink-0 text-white"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                            />
                                        </svg>
      
                                        <span className="flex-1 text-white">(925) 516-8880</span>
                                    </a>
                                </li>
      
                                <li className="flex items-start justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end">
                                    <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5 shrink-0 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                    </svg>
                                    <a  target="_blank"  rel="noreferrer" href = "https://maps.app.goo.gl/uuecJaWrUTHV3TMh8" className="-mt-0.5 flex-1 not-italic text-white">
                                        5611 Lone Tree Wy #100, Brentwood, CA 94513                   
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
      
                <div className="mt-12 border-t border-gray-100 pt-6">
                    <div className="text-center sm:flex sm:justify-between sm:text-left">
                        <p className="text-sm text-gray-200">
                            <span className="block sm:inline">All rights reserved.</span>
                        </p>  
        
                        <p className="mt-4 text-sm text-gray-200 sm:order-first sm:mt-0">
                            &copy; 2024 CreAsian Flavors of Vietnam
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};